import * as React from 'react';
import shortid from 'shortid';
import { MuiThemeProvider, createMuiTheme, withTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import Typography from '@material-ui/core/Typography';

import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// docs: https://material-ui.com/customization/default-theme/
export const theme = createMuiTheme({
	palette: {
		text: { primary: '#141417', secondary: 'rgba(0,0,0,0.58)' },
		primary: { main: '#1793FF', contrastText: '#fff' },
		secondary: { main: '#fff', contrastText: '#1D1F26' },
	},
	typography: { fontSize: 18 },
});

export const ThemeProvider = ({ children }) => (
	<MuiThemeProvider theme={theme}>
		<CssBaseline />
		<StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
	</MuiThemeProvider>
);

export { withTheme };

export { Typography };
export const Title = (props) => <Typography variant="title" {...props} />;
export const Headline = (props) => <Typography variant="headline" {...props} />;
export const Body = (props) => <Typography variant="body1" {...props} />;

export class SelectField extends React.Component {
	state = { value: '', open: false };
	inputProps = { id: shortid.generate() };

	handleChange = ({ target: { value } }) => this.setState({ value });
	handleOpen = () => this.setState({ open: true });
	handleClose = () => this.setState({ open: false });

	focus = this.handleOpen;

	render = () => {
		const { label, items, value, onChange } = this.props;
		return (
			<FormControl fullWidth>
				<InputLabel htmlFor={this.inputProps.id}>{label}</InputLabel>
				<Select
					inputProps={this.inputProps}
					value={value || this.state.value}
					onChange={onChange || this.handleChange}
					onOpen={this.handleOpen}
					onClose={this.handleClose}
					open={this.state.open}
					autoWidth
				>
					{items.map((item) => (
						<MenuItem key={item.key} value={item.key}>
							{item.Icon ? <ListItemIcon>{item.Icon}</ListItemIcon> : null}
							<ListItemText>{item.label}</ListItemText>
						</MenuItem>
					))}
				</Select>
			</FormControl>
		);
	};
}

export class DropDownMenu extends React.Component {
	state = { anchorEl: null };
	handleOpen = (e) => this.setState({ anchorEl: e.currentTarget });
	handleClose = () => this.setState({ anchorEl: null });

	handleSelect = (item) => () => {
		item.onClick && item.onClick();
		this.handleClose();
	};

	render = () => (
		<React.Fragment>
			<IconButton color="inherit" onClick={this.handleOpen}>
				<MoreVertIcon />
			</IconButton>
			<Menu
				open={Boolean(this.state.anchorEl)}
				anchorEl={this.state.anchorEl}
				onClose={this.handleClose}
			>
				{this.props.menuItems.map((item) => (
					<MenuItem key={item.key} onClick={this.handleSelect(item)}>
						{item.Icon ? <ListItemIcon>{item.Icon}</ListItemIcon> : null}
						<ListItemText>{item.label}</ListItemText>
					</MenuItem>
				))}
			</Menu>
		</React.Fragment>
	);
}

// from https://material.io/tools/icons/
export { default as TicketIcon } from '@material-ui/icons/LocalActivity';
export { default as GiftcardIcon } from '@material-ui/icons/CardGiftcard';
export { default as SettingsIcon } from '@material-ui/icons/Settings';
export { default as DeleteIcon } from '@material-ui/icons/DeleteForever';
export { default as AddIcon } from '@material-ui/icons/Add';
export { default as SelectIcon } from '@material-ui/icons/ArrowDropDown';
export { default as CheckIcon } from '@material-ui/icons/CheckCircle';
export { default as CheckmarkIcon } from '@material-ui/icons/Check';
export { default as ErrorIcon } from '@material-ui/icons/Error';
export { default as HelpIcon } from '@material-ui/icons/Help';
export { default as DialpadIcon } from '@material-ui/icons/Dialpad';
export { default as BackspaceIcon } from '@material-ui/icons/Backspace';
export { default as CancelIcon } from '@material-ui/icons/Cancel';
export { default as BonuscoinIcon } from '@material-ui/icons/Stars';
export { default as InfoIcon } from '@material-ui/icons/Info';
export { default as LogoutIcon } from '@material-ui/icons/ExitToApp';
export { default as KeyIcon } from '@material-ui/icons/VpnKey';
export { default as VisibileIcon } from '@material-ui/icons/Visibility';
export { default as HiddenIcon } from '@material-ui/icons/VisibilityOff';
export { default as CameraIcon } from '@material-ui/icons/Camera';
export { default as VideocamIcon } from '@material-ui/icons/Videocam';
export { default as VideocamOffIcon } from '@material-ui/icons/VideocamOff';

export { default as Button } from '@material-ui/core/Button';
export { default as IconButton } from '@material-ui/core/IconButton';
export { default as CircularProgress } from '@material-ui/core/CircularProgress';
export { default as TextField } from '@material-ui/core/TextField';
export { default as ButtonBase } from '@material-ui/core/ButtonBase';
export { default as Popover } from '@material-ui/core/Popover';
export { default as InputAdornment } from '@material-ui/core/InputAdornment';
export { default as Tooltip } from '@material-ui/core/Tooltip';

export { default as Card } from '@material-ui/core/Card';
export { default as CardActions } from '@material-ui/core/CardActions';
export { default as CardContent } from '@material-ui/core/CardContent';
export { default as CardMedia } from '@material-ui/core/CardMedia';

export { default as Grid } from '@material-ui/core/Grid';

export { default as AppBar } from '@material-ui/core/AppBar';
export { default as Toolbar } from '@material-ui/core/Toolbar';
export { default as Tabs } from '@material-ui/core/Tabs';
export { default as Tab } from '@material-ui/core/Tab';

export { default as Stepper } from '@material-ui/core/Stepper';
export { default as Step } from '@material-ui/core/Step';
export { default as StepLabel } from '@material-ui/core/StepLabel';
export { default as StepContent } from '@material-ui/core/StepContent';

export { default as Dialog } from '@material-ui/core/Dialog';
export { default as DialogActions } from '@material-ui/core/DialogActions';
export { default as DialogContent } from '@material-ui/core/DialogContent';
export { default as DialogContentText } from '@material-ui/core/DialogContentText';
export { default as DialogTitle } from '@material-ui/core/DialogTitle';



// WEBPACK FOOTER //
// ./src/material-ui.js